import { z } from 'zod';

import { Box, Form } from '@ekhodealer/ekho-common/rev';

const tradeInSchema = z.object({
	enabled: z.boolean().optional(),
});

export function TradeInValuationSection() {
	return (
		<Box padding='24' background='secondary' rounding='12'>
			<div data-settings-disabled>
				<Form
					name='ai-bdc-trade-in-valuation'
					schema={tradeInSchema}
					defaultValues={{ enabled: false }}
					onSubmit={async () => ({ isSuccess: false })}
					title='Trade-in valuation'
					titleLevel='subgroup'
					titleWeight='semibold'
					titleMaxWidth='full'
					description='Allow the AI to collect vehicle details and provide estimated trade-in values during conversations.'
					tag={{ children: 'Coming soon', size: 'small' }}
					toggle={{ fieldName: 'enabled' }}>
					{null}
				</Form>
			</div>
		</Box>
	);
}
